<ia-panel class="tw-mt-5 tw-font-sans hb-group:tw-mx-6 sm:tw-mt-7.5">
  @if (!isHb) {
    <div header class="tw-w-full tw-justify-between mb-group:tw-flex mb-group:tw-flex-row">
      <span>{{ 'screens.summary.title' | translate }}</span>
    </div>
  }
  @if (
    {
      personalInformation: personalInformation$ | async,
      terminationInformation: terminationInformation$ | async,
      terminationInformationText: terminationInformationText$ | async,
      physicalPerson: (personalInformation$ | async)?.identification === PhysicalPerson,
    };
    as vm
  ) {
    <div content>
      <div class="mb-group:tw-p-7.5">
        <section class="tw-flex tw-flex-col tw-gap-8">
          <div class="tw-inline-flex tw-items-center">
            @if (isHb) {
              <div
                class="tw-inline-flex tw-w-full tw-items-center tw-rounded-2xl tw-bg-azure tw-py-1"
              >
                <ia-icon
                  name="nhb:bulb_nhb"
                  class="tw-m-4 tw-w-4 tw-shrink-0 tw-text-cerulean-3"
                  color="#0a7e9e"
                />
                <p class="tw-max-w-2xl tw-text-hb-base tw-text-hb-brand-1100">
                  {{ 'screens.terminationInformation.panel.contact' | translate }}
                </p>
              </div>
            } @else {
              <ia-icons
                name="information_white"
                class="tw-mr-4 tw-w-8 tw-shrink-0"
                color="#008854"
              />

              <p class="tw-max-w-2xl tw-font-semibold hb-group:tw-text-cerulean">
                {{ 'screens.summary.section2.information' | translate }}
                <button
                  data-test-id="'btn-contact-us"
                  type="button"
                  class="tw-cursor-pointer tw-underline"
                  (click)="onContactUs()"
                  (keydown.enter)="onContactUs()"
                >
                  {{ 'screens.summary.section2.contactUs' | translate }}
                </button>
              </p>
            }
          </div>
          <p
            class="mb-group:tw-font-semibold hb-group:tw-font-hello-type-next hb-group:tw-text-hb-lg hb-group:tw-font-medium hb-group:tw-text-midnight-green"
            [innerHTML]="'screens.summary.section1.title' | translate"
          ></p>
          @if (
            vm.terminationInformation?.terminationType === TerminationType.TERMINATE &&
            vm.terminationInformation?.contractType === insurance
          ) {
            <div>
              @for (content of 'screens.summary.content' | translate; track content) {
                <p
                  class="mb-group:tw-text-eerie-black hb-group:tw-text-midnight-green"
                  [innerHTML]="content"
                ></p>
              }
            </div>
          }
          <p
            class="mb-group:tw-font-semibold hb-group:tw-font-hello-type-next hb-group:tw-text-hb-lg hb-group:tw-font-medium hb-group:tw-text-midnight-green"
            [innerHTML]="'screens.summary.section2.title' | translate: { typology }"
          ></p>
        </section>
        <section
          class="hb-group:tw-mt-3 hb-group:tw-rounded-2xl hb-group:tw-border hb-group:tw-border-platinum"
        >
          <div class="tw-mt-7.5 tw-flex tw-flex-col sm:tw-flex-row">
            <p
              class="tw-basis-1/4 tw-pb-3.5 tw-text-eerie-black hb-group:tw-pl-4 hb-group:tw-text-midnight-green sm:tw-w-61 sm:tw-border-b sm:tw-border-b-platinum"
            >
              @if (vm.physicalPerson) {
                {{ 'screens.summary.section2.lastName' | translate }}
              }
              @if (!vm.physicalPerson) {
                {{ 'screens.summary.section2.companyName' | translate }}
              }
            </p>
            <div
              class="tw-ml-0 tw-flex tw-basis-1/2 tw-items-center tw-break-all tw-border-b tw-border-b-platinum tw-pb-3.5 tw-font-semibold tw-text-slate-gray hb-group:tw-ml-0 hb-group:tw-basis-3/4 hb-group:tw-pl-0 hb-group:tw-font-normal mb-group:sm:tw-ml-5"
            >
              <p class="hb-group:sm:tw-ml-5">
                {{ vm.personalInformation?.fullName }}
              </p>
            </div>
          </div>
          @if (vm.physicalPerson && vm.personalInformation?.firstName) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-basis-1/4 tw-pb-3.5 tw-text-eerie-black hb-group:tw-pl-4 hb-group:tw-text-midnight-green sm:tw-w-61 sm:tw-border-b sm:tw-border-b-platinum"
              >
                {{ 'screens.summary.section2.firstName' | translate }}
              </p>
              <div
                class="tw-ml-0 tw-flex tw-basis-1/2 tw-items-center tw-break-all tw-border-b tw-border-b-platinum tw-pb-3.5 tw-font-semibold tw-text-slate-gray hb-group:tw-ml-0 hb-group:tw-basis-3/4 hb-group:tw-pl-0 hb-group:tw-font-normal mb-group:sm:tw-ml-5"
              >
                <p class="hb-group:sm:tw-ml-5">
                  {{ vm.personalInformation?.firstName }}
                </p>
              </div>
            </div>
          }
          @if (!vm.physicalPerson) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-basis-1/4 tw-pb-3.5 tw-text-eerie-black hb-group:tw-pl-4 hb-group:tw-text-midnight-green sm:tw-w-61 sm:tw-border-b sm:tw-border-b-platinum"
              >
                {{ 'screens.summary.section2.applicantLastName' | translate }}
              </p>
              <div
                class="tw-ml-0 tw-flex tw-basis-1/2 tw-items-center tw-break-all tw-border-b tw-border-b-platinum tw-pb-3.5 tw-font-semibold tw-text-slate-gray hb-group:tw-ml-0 hb-group:tw-basis-3/4 hb-group:tw-pl-0 hb-group:tw-font-normal mb-group:sm:tw-ml-5"
              >
                <p class="hb-group:sm:tw-ml-5">
                  {{ vm.personalInformation?.applicantLastName }}
                </p>
              </div>
            </div>
          }
          @if (!vm.physicalPerson) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-basis-1/4 tw-pb-3.5 tw-text-eerie-black hb-group:tw-pl-4 hb-group:tw-text-midnight-green sm:tw-w-61 sm:tw-border-b sm:tw-border-b-platinum"
              >
                {{ 'screens.summary.section2.applicantFirstName' | translate }}
              </p>
              <div
                class="tw-ml-0 tw-flex tw-basis-1/2 tw-items-center tw-break-all tw-border-b tw-border-b-platinum tw-pb-3.5 tw-font-semibold tw-text-slate-gray hb-group:tw-ml-0 hb-group:tw-basis-3/4 hb-group:tw-pl-0 hb-group:tw-font-normal mb-group:sm:tw-ml-5"
              >
                <p class="hb-group:sm:tw-ml-5">
                  {{ vm.personalInformation?.applicantFirstName }}
                </p>
              </div>
            </div>
          }
          @if (vm.physicalPerson || !isConnected) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-basis-1/4 tw-pb-3.5 tw-text-eerie-black hb-group:tw-pl-4 hb-group:tw-text-midnight-green sm:tw-w-61 sm:tw-border-b sm:tw-border-b-platinum"
              >
                @if (vm.physicalPerson) {
                  {{ 'screens.summary.section2.dateOfBirth' | translate }}
                }
                @if (!vm.physicalPerson) {
                  {{ 'screens.summary.section2.applicantDateOfBirth' | translate }}
                }
              </p>
              <div
                class="tw-ml-0 tw-flex tw-basis-1/2 tw-items-center tw-border-b tw-border-b-platinum tw-pb-3.5 tw-font-semibold tw-text-slate-gray hb-group:tw-ml-0 hb-group:tw-basis-3/4 hb-group:tw-pl-0 hb-group:tw-font-normal mb-group:sm:tw-ml-5"
              >
                <p class="hb-group:sm:tw-ml-5">
                  @if (isConnected) {
                    {{ vm.personalInformation?.dateOfBirth }}
                  }
                  @if (!isConnected) {
                    {{ vm.personalInformation?.dateOfBirth | date: 'dd/MM/yyyy' }}
                  }
                </p>
              </div>
            </div>
          }
          @if (vm.physicalPerson || !isConnected) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-basis-1/4 tw-pb-3.5 tw-text-eerie-black hb-group:tw-pl-4 hb-group:tw-text-midnight-green sm:tw-w-61 sm:tw-border-b sm:tw-border-b-platinum"
              >
                @if (vm.physicalPerson) {
                  {{ 'screens.summary.section2.communeOfBirth' | translate }}
                }
                @if (!vm.physicalPerson) {
                  {{ 'screens.summary.section2.applicantCommuneOfBirth' | translate }}
                }
              </p>
              <div
                class="tw-ml-0 tw-flex tw-basis-1/2 tw-items-center tw-break-all tw-border-b tw-border-b-platinum tw-pb-3.5 tw-font-semibold tw-text-slate-gray hb-group:tw-ml-0 hb-group:tw-basis-3/4 hb-group:tw-pl-0 hb-group:tw-font-normal mb-group:sm:tw-ml-5"
              >
                <p class="hb-group:sm:tw-ml-5">
                  {{ vm.personalInformation?.countryOfBirth }}
                </p>
              </div>
            </div>
          }
          <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
            <p
              class="tw-basis-1/4 tw-pb-3.5 tw-text-eerie-black hb-group:tw-pl-4 hb-group:tw-text-midnight-green sm:tw-w-61 sm:tw-border-b sm:tw-border-b-platinum"
            >
              {{ 'screens.summary.section2.channelType' | translate }}
            </p>
            <div
              class="tw-ml-0 tw-flex tw-basis-1/2 tw-items-center tw-border-b tw-border-b-platinum tw-pb-3.5 tw-font-semibold tw-text-slate-gray hb-group:tw-ml-0 hb-group:tw-basis-3/4 hb-group:tw-pl-0 hb-group:tw-font-normal mb-group:sm:tw-ml-5"
            >
              <p class="hb-group:sm:tw-ml-5">
                {{ vm.personalInformation?.channelType }}
              </p>
            </div>
          </div>
          @if (vm.personalInformation?.channelType === Email) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-basis-1/4 tw-pb-3.5 tw-text-eerie-black hb-group:tw-pl-4 hb-group:tw-text-midnight-green sm:tw-w-61 sm:tw-border-b sm:tw-border-b-platinum"
              >
                {{ 'screens.summary.section2.mail' | translate }}
              </p>
              <div
                class="tw-ml-0 tw-flex tw-basis-1/2 tw-items-center tw-break-all tw-border-b tw-border-b-platinum tw-pb-3.5 tw-font-semibold tw-text-slate-gray hb-group:tw-ml-0 hb-group:tw-basis-3/4 hb-group:tw-pl-0 hb-group:tw-font-normal mb-group:sm:tw-ml-5"
              >
                <p class="hb-group:sm:tw-ml-5">
                  {{ vm.personalInformation?.email }}
                </p>
              </div>
            </div>
          }
          @if (vm.personalInformation?.channelType === Paper) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-basis-1/4 tw-pb-3.5 tw-text-eerie-black hb-group:tw-pl-4 hb-group:tw-text-midnight-green sm:tw-w-61 sm:tw-border-b sm:tw-border-b-platinum"
              >
                {{ 'screens.summary.section2.address' | translate }}
              </p>
              <div
                class="tw-ml-0 tw-flex tw-basis-1/2 tw-items-center tw-break-all tw-border-b tw-border-b-platinum tw-pb-3.5 tw-font-semibold tw-text-slate-gray hb-group:tw-ml-0 hb-group:tw-basis-3/4 hb-group:tw-pl-0 hb-group:tw-font-normal mb-group:sm:tw-ml-5"
              >
                <p class="hb-group:sm:tw-ml-5">
                  {{ vm.personalInformation?.address }} {{ vm.personalInformation?.postalCode }}
                  {{ vm.personalInformation?.city }}
                </p>
              </div>
            </div>
          }
          @if (vm.terminationInformation?.contractType) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-basis-1/4 tw-pb-3.5 tw-text-eerie-black hb-group:tw-pl-4 hb-group:tw-text-midnight-green sm:tw-w-61 sm:tw-border-b sm:tw-border-b-platinum"
              >
                {{ 'screens.summary.section2.contractType' | translate }}
              </p>
              <div
                class="tw-ml-0 tw-flex tw-basis-1/2 tw-items-center tw-border-b tw-border-b-platinum tw-pb-3.5 tw-font-semibold tw-text-slate-gray hb-group:tw-ml-0 hb-group:tw-basis-3/4 hb-group:tw-pl-0 hb-group:tw-font-normal mb-group:sm:tw-ml-5"
              >
                <p class="hb-group:sm:tw-ml-5">
                  {{ vm.terminationInformation?.contractType }}
                </p>
              </div>
            </div>
          }
          @if (vm.terminationInformationText?.terminationType) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-basis-1/4 tw-pb-3.5 tw-text-eerie-black hb-group:tw-pl-4 hb-group:tw-text-midnight-green sm:tw-w-61 sm:tw-border-b sm:tw-border-b-platinum"
              >
                {{ 'screens.summary.section2.terminationType' | translate }}
              </p>
              <div
                class="tw-ml-0 tw-flex tw-basis-1/2 tw-items-center tw-border-b tw-border-b-platinum tw-pb-3.5 tw-font-semibold tw-text-slate-gray hb-group:tw-ml-0 hb-group:tw-basis-3/4 hb-group:tw-pl-0 hb-group:tw-font-normal mb-group:sm:tw-ml-5"
              >
                <p class="hb-group:sm:tw-ml-5">
                  {{ vm.terminationInformationText?.terminationType | translate }}
                </p>
              </div>
            </div>
          }
          @if (vm.terminationInformation?.contract) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-basis-1/4 tw-pb-3.5 tw-text-eerie-black hb-group:tw-pl-4 hb-group:tw-text-midnight-green sm:tw-w-61 sm:tw-border-b sm:tw-border-b-platinum"
              >
                {{ 'screens.summary.section2.insurance' | translate }}
              </p>
              <div
                class="tw-ml-0 tw-flex tw-basis-1/2 tw-items-center tw-border-b tw-border-b-platinum tw-pb-3.5 tw-font-semibold tw-text-slate-gray hb-group:tw-ml-0 hb-group:tw-basis-3/4 hb-group:tw-pl-0 hb-group:tw-font-normal mb-group:sm:tw-ml-5"
              >
                <p class="hb-group:sm:tw-ml-5">
                  {{ vm.terminationInformation?.contract }}
                </p>
              </div>
            </div>
          }
          @if (vm.terminationInformation?.contractName) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-basis-1/4 tw-pb-3.5 tw-text-eerie-black hb-group:tw-pl-4 hb-group:tw-text-midnight-green sm:tw-w-61 sm:tw-border-b sm:tw-border-b-platinum"
              >
                {{ 'screens.summary.section2.insuranceName' | translate }}
              </p>
              <div
                class="tw-ml-0 tw-flex tw-basis-1/2 tw-items-center tw-break-all tw-border-b tw-border-b-platinum tw-pb-3.5 tw-font-semibold tw-text-slate-gray hb-group:tw-ml-0 hb-group:tw-basis-3/4 hb-group:tw-pl-0 hb-group:tw-font-normal mb-group:sm:tw-ml-5"
              >
                <p class="hb-group:sm:tw-ml-5">
                  {{ vm.terminationInformation?.contractName }}
                </p>
              </div>
            </div>
          }
          @if (vm.terminationInformation?.contractNumber) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-basis-1/4 tw-pb-3.5 tw-text-eerie-black hb-group:tw-pl-4 hb-group:tw-text-midnight-green sm:tw-w-61 sm:tw-border-b sm:tw-border-b-platinum"
              >
                {{ 'screens.summary.section2.contractNumber' | translate }}
              </p>
              <div
                class="tw-ml-0 tw-flex tw-basis-1/2 tw-items-center tw-break-all tw-border-b tw-border-b-platinum tw-pb-3.5 tw-font-semibold tw-text-slate-gray hb-group:tw-ml-0 hb-group:tw-basis-3/4 hb-group:tw-pl-0 hb-group:tw-font-normal mb-group:sm:tw-ml-5"
              >
                <p class="hb-group:sm:tw-ml-5">
                  {{ vm.terminationInformation?.contractNumber }}
                </p>
              </div>
            </div>
          }
          @if (
            vm.terminationInformation?.terminationDate &&
            vm.terminationInformation?.terminationType === TerminationType.TERMINATE
          ) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-basis-1/4 tw-pb-3.5 tw-text-eerie-black hb-group:tw-pl-4 hb-group:tw-text-midnight-green sm:tw-w-61 sm:tw-border-b sm:tw-border-b-platinum"
              >
                {{ 'screens.summary.section2.terminationDate' | translate }}
              </p>
              <div
                class="tw-ml-0 tw-flex tw-basis-1/2 tw-items-center tw-border-b tw-border-b-platinum tw-pb-3.5 tw-font-semibold tw-text-slate-gray hb-group:tw-ml-0 hb-group:tw-basis-3/4 hb-group:tw-pl-0 hb-group:tw-font-normal mb-group:sm:tw-ml-5"
              >
                <p class="hb-group:sm:tw-ml-5">
                  @if (vm.terminationInformation?.contractType !== insurance) {
                    {{ vm.terminationInformation?.terminationDate }}
                  }
                  @if (vm.terminationInformation?.contractType === insurance) {
                    {{ vm.terminationInformation?.terminationDate | date: 'dd/MM/yyyy' }}
                  }
                </p>
              </div>
            </div>
          }
          @if (
            vm.terminationInformation?.terminationType === TerminationType.TERMINATE &&
            vm.terminationInformation?.terminationReason
          ) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-basis-1/4 tw-pb-3.5 tw-text-eerie-black hb-group:tw-pl-4 hb-group:tw-text-midnight-green sm:tw-w-61 sm:tw-border-b sm:tw-border-b-platinum"
              >
                {{ 'screens.summary.section2.terminationReason' | translate }}
              </p>
              <div
                class="tw-ml-0 tw-flex tw-basis-1/2 tw-items-center tw-border-b tw-border-b-platinum tw-pb-3.5 tw-font-semibold tw-text-slate-gray hb-group:tw-ml-0 hb-group:tw-basis-3/4 hb-group:tw-pl-0 hb-group:tw-font-normal mb-group:sm:tw-ml-5"
              >
                <p class="hb-group:sm:tw-ml-5">
                  {{ vm.terminationInformation?.terminationReason }}
                </p>
              </div>
            </div>
          }
          @if (vm.terminationInformation?.otherReason) {
            <div class="tw-mt-3.5 tw-flex tw-flex-col sm:tw-flex-row">
              <p
                class="tw-basis-1/4 tw-pb-3.5 tw-text-eerie-black hb-group:tw-pl-4 hb-group:tw-text-midnight-green sm:tw-w-61 sm:tw-border-b sm:tw-border-b-platinum"
              >
                {{ 'screens.summary.section2.customerEntry' | translate }}
              </p>
              <div
                class="tw-ml-0 tw-flex tw-basis-1/2 tw-items-center tw-break-all tw-border-b tw-border-b-platinum tw-pb-3.5 tw-font-semibold tw-text-slate-gray hb-group:tw-ml-0 hb-group:tw-basis-3/4 hb-group:tw-pl-0 hb-group:tw-font-normal mb-group:sm:tw-ml-5"
              >
                <p class="hb-group:sm:tw-ml-5">
                  {{ vm.terminationInformation?.otherReason }}
                </p>
              </div>
            </div>
          }
        </section>
      </div>
    </div>
  }
</ia-panel>

<div class="tw-mt-5 tw-flex tw-flex-col tw-items-center tw-justify-end tw-gap-4 md:tw-flex-row">
  <button
    (click)="onPrevious()"
    [isProcessing]="false"
    class="tw-h-10.5 tw-font-semibold hb-group:tw-uppercase"
    iaButton
    id="btn-summary-previous"
    data-test-id="btn-summary-previous"
    size="large"
    type="button"
    variant="secondary"
  >
    {{ 'screens.summary.buttons.buttonPrevious.title' | translate }}
  </button>
  <button
    (click)="onSubmit()"
    [isProcessing]="false"
    class="tw-mt-4 tw-font-semibold hb-group:tw-h-10.5 hb-group:tw-uppercase md:tw-mt-0"
    iaButton
    id="btn-summary-next"
    data-test-id="btn-summary-next"
    size="large"
    type="button"
  >
    {{ 'screens.summary.buttons.buttonConfirm.title' | translate }}
  </button>
</div>
